export class SetThree {
  static readonly type = '[Three] set three value';
  constructor(public payload: any) { }
}
export class SetPage {
  static readonly type = '[Page] set selected Page';
  constructor(public payload: any) { }
}
